import { render, staticRenderFns } from "./PlanoDeAplicacao.vue?vue&type=template&id=a22c2dbe&"
import script from "./PlanoDeAplicacao.vue?vue&type=script&lang=js&"
export * from "./PlanoDeAplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports